import { render, staticRenderFns } from "./DriverContractEntity.vue?vue&type=template&id=5be54297&"
import script from "./DriverContractEntity.vue?vue&type=script&lang=js&"
export * from "./DriverContractEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be54297')) {
      api.createRecord('5be54297', component.options)
    } else {
      api.reload('5be54297', component.options)
    }
    module.hot.accept("./DriverContractEntity.vue?vue&type=template&id=5be54297&", function () {
      api.rerender('5be54297', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DriverContractEntity.vue"
export default component.exports